// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__38tU4","container":"Contact_container__9Ekpx","name":"Contact_name__qxmO9"};